import FilterSet from '@/lib/store/FilterSet'

const filters = new FilterSet()

filters.addFilter ('partner', { in_network: 1 })
filters.addFilter ('users', { inactive: null })

export default { ...filters.getModule() }
